import { v4 as uuidv4 } from 'uuid';
import chatttSDK from 'services/chattt';

export const getUnionId = async () => {
  if (typeof chatttSDK?.app?.info === 'function') {
    const res = await chatttSDK?.app?.info?.();
    return res.deviceId;
  }
  const unionId = localStorage.getItem('temp-unionId');
  const [id, ts] = (unionId || '').split('_');
  if (id && ts && Date.now() < Number(ts)) {
    return id;
  }
  const newUnionId = uuidv4();
  localStorage.setItem('temp-unionId', `${newUnionId}_${Date.now() + 24 * 60 * 60 * 1000}`);
  return newUnionId;
};
